import type {ReactElement} from 'react';
import React from 'react';
import BrandLogos from '@Components/editor-brands/components/brand-logos';
import {useSelectedTab} from '@Components/tabs';
import EditorBrands from '@Components/editor-brands';
import {BrandAssetName} from '@Components/editor-brands/editor-brands.types';
import {UploadsMediaSubTab, USER_LOGOS_GRID_ID, USER_UPLOADS_MEDIA_SUB_TABS, USER_UPLOADS_SELECTION_GRID_ID} from '@Panels/user-media-panel/user-media-panel.types';
import {onAddBrandAssetClickedHandler} from '@Components/poster-editor/library/poster-editor-library';
import type {GridItemStorage} from '@Components/base-grid/components/grid-item';
import {getSelectedGridItems, toggleGridItemSelection} from '@Components/base-grid';
import {useAppDispatch, useAppSelector} from '@/hooks';

interface BrandLogoSectionProps {
  maxSelectionNumber?: number;

  addSelectedItems(): void;
  defaultActiveSubTab?: UploadsMediaSubTab;
}

export function BrandLogoSection({defaultActiveSubTab = UploadsMediaSubTab.UPLOADS, ...props}: BrandLogoSectionProps): ReactElement | null {
  const activeSubtab = useSelectedTab(USER_UPLOADS_MEDIA_SUB_TABS, defaultActiveSubTab);
  const selectedGridItems = useAppSelector((state) => {
    return getSelectedGridItems(state, USER_UPLOADS_SELECTION_GRID_ID);
  });
  const dispatch = useAppDispatch();

  const onGridItemClicked = (gridItem: GridItemStorage, isDoubleClick: boolean): void => {
    if (isDoubleClick && selectedGridItems.length === 1 && selectedGridItems[0].id === gridItem.id) {
      props.addSelectedItems();
      return;
    }

    dispatch(
      toggleGridItemSelection({
        gridItemId: gridItem.id,
        gridSelectionGroupId: USER_UPLOADS_SELECTION_GRID_ID,
      })
    );
  };

  return activeSubtab === UploadsMediaSubTab.LOGO ? (
    <EditorBrands
      className="spacing-p-t-6"
      brandAsset={BrandAssetName.LOGOS}
      onAddBrandAsset={(): void => {
        void onAddBrandAssetClickedHandler();
      }}
    >
      <BrandLogos selectionGroupId={USER_UPLOADS_SELECTION_GRID_ID} onItemClicked={onGridItemClicked} gridId={USER_LOGOS_GRID_ID} maxSelectionNumber={props.maxSelectionNumber} />
    </EditorBrands>
  ) : null;
}
